import { create } from 'zustand';

// Draft response data for an alert that persists across navigation
export interface DraftResponseData {
  notes?: string;
  policeCalled?: boolean;
  policeId?: string;
  offenceType?: string;
  weaponsSeen?: boolean;
  weapons?: string;
}

interface IntruderState {
  isLive: boolean;
  setIsLive: (isLive: boolean) => void;
  isControllerMode: boolean;
  setControllerMode: (isControllerMode: boolean) => void;
  // Draft response data keyed by alertId to persist across navigation
  draftResponses: Record<string, DraftResponseData>;
  setDraftResponse: (alertId: string, data: Partial<DraftResponseData>) => void;
  clearDraftResponse: (alertId: string) => void;
}

export const useIntruderStore = create<IntruderState>((set) => ({
  isLive: false,
  setIsLive: (isLive) => set({ isLive }),
  isControllerMode: false,
  setControllerMode: (isControllerMode) => set({ isControllerMode }),
  draftResponses: {},
  setDraftResponse: (alertId, data) =>
    set((state) => ({
      draftResponses: {
        ...state.draftResponses,
        [alertId]: { ...state.draftResponses[alertId], ...data },
      },
    })),
  clearDraftResponse: (alertId) =>
    set((state) => {
      const { [alertId]: _, ...rest } = state.draftResponses;
      return { draftResponses: rest };
    }),
}));
